var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 160 224)",
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 384,
    width: 32,
    height: 32,
    transform: "rotate(90 160 384)",
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(90 161 32)",
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(90 353 32)",
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 416,
    width: 32,
    height: 32,
    transform: "rotate(90 224 416)",
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    width: 32,
    height: 32,
    transform: "rotate(90 225 0)",
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 416,
    width: 32,
    height: 32,
    transform: "rotate(90 288 416)",
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    width: 32,
    height: 32,
    transform: "rotate(90 289 0)",
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 384,
    width: 32,
    height: 32,
    transform: "rotate(90 352 384)",
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 352,
    width: 32,
    height: 32,
    transform: "rotate(90 384 352)",
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 416 224)",
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 288,
    width: 32,
    height: 32,
    transform: "rotate(-180 448 288)",
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 192 224)",
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 192,
    width: 32,
    height: 32,
    transform: "rotate(90 192 192)",
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 160,
    width: 32,
    height: 32,
    transform: "rotate(90 224 160)",
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 160,
    width: 32,
    height: 32,
    transform: "rotate(90 256 160)",
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 192,
    width: 32,
    height: 32,
    transform: "rotate(90 288 192)",
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 288 224)",
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 256,
    width: 32,
    height: 32,
    transform: "rotate(90 224 256)",
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    width: 32,
    height: 32,
    transform: "rotate(90 256 256)",
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 224,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 224,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 288,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 192,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 192,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 256,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 352,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 352,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 96,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 160,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 192,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 320,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 352,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 352,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 352,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 384,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 384,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 352,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 352,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 352,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 384,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 384,
    width: 32,
    height: 32,
    fill: "white"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 128,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 192,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 160,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 192,
    width: 32,
    height: 32,
    fill: "#FB0102"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(90 289 32)",
    fill: "#FB0102"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 64,
    width: 32,
    height: 32,
    transform: "rotate(90 225 64)",
    fill: "#FB0102"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 64,
    width: 32,
    height: 32,
    transform: "rotate(90 353 64)",
    fill: "#FB0102"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 225 96)",
    fill: "#FB0102"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 353 96)",
    fill: "#FB0102"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 385 96)",
    fill: "#FB0102"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 225 128)",
    fill: "#FB0102"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 353 128)",
    fill: "#FB0102"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 385 128)",
    fill: "#FB0102"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 192,
    width: 32,
    height: 32,
    transform: "rotate(90 160 192)",
    fill: "#FB0102"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 160,
    width: 32,
    height: 32,
    transform: "rotate(90 192 160)",
    fill: "#FB0102"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 160,
    width: 32,
    height: 32,
    transform: "rotate(90 352 160)",
    fill: "#FB0102"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 160,
    width: 32,
    height: 32,
    transform: "rotate(90 384 160)",
    fill: "#FB0102"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 160,
    width: 32,
    height: 32,
    transform: "rotate(90 416 160)",
    fill: "#FB0102"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 192,
    width: 32,
    height: 32,
    transform: "rotate(90 384 192)",
    fill: "#FB0102"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 192,
    width: 32,
    height: 32,
    transform: "rotate(90 416 192)",
    fill: "#FB0102"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(90 225 32)",
    fill: "#FB0102"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 64,
    width: 32,
    height: 32,
    transform: "rotate(90 161 64)",
    fill: "#FB0102"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 64,
    width: 32,
    height: 32,
    transform: "rotate(90 289 64)",
    fill: "#FB0102"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 161 96)",
    fill: "#FB0102"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 289 96)",
    fill: "#FB0102"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 161 128)",
    fill: "#FB0102"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 289 128)",
    fill: "#FB0102"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(90 257 32)",
    fill: "#FB0102"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 64,
    width: 32,
    height: 32,
    transform: "rotate(90 193 64)",
    fill: "#FB0102"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 64,
    width: 32,
    height: 32,
    transform: "rotate(90 321 64)",
    fill: "#FB0102"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 193 96)",
    fill: "#FB0102"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 321 96)",
    fill: "#FB0102"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 193 128)",
    fill: "#FB0102"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 321 128)",
    fill: "#FB0102"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 192,
    width: 32,
    height: 32,
    transform: "rotate(90 128 192)",
    fill: "#FB0102"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 32,
    height: 32,
    transform: "rotate(90 160 160)",
    fill: "#FB0102"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 160,
    width: 32,
    height: 32,
    transform: "rotate(90 320 160)",
    fill: "#FB0102"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 192,
    width: 32,
    height: 32,
    transform: "rotate(90 352 192)",
    fill: "#FB0102"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(90 193 32)",
    fill: "#FB0102"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 64,
    width: 32,
    height: 32,
    transform: "rotate(90 129 64)",
    fill: "#FB0102"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 64,
    width: 32,
    height: 32,
    transform: "rotate(90 257 64)",
    fill: "#FB0102"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 129 96)",
    fill: "#FB0102"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 96,
    width: 32,
    height: 32,
    transform: "rotate(90 257 96)",
    fill: "#FB0102"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 129 128)",
    fill: "#FB0102"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 128,
    width: 32,
    height: 32,
    transform: "rotate(90 257 128)",
    fill: "#FB0102"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 128 224)",
    fill: "black"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 384,
    width: 32,
    height: 32,
    transform: "rotate(90 128 384)",
    fill: "black"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(90 129 32)",
    fill: "black"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(90 321 32)",
    fill: "black"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 416,
    width: 32,
    height: 32,
    transform: "rotate(90 192 416)",
    fill: "black"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    width: 32,
    height: 32,
    transform: "rotate(90 193 0)",
    fill: "black"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 416,
    width: 32,
    height: 32,
    transform: "rotate(90 256 416)",
    fill: "black"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    width: 32,
    height: 32,
    transform: "rotate(90 257 0)",
    fill: "black"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 384,
    width: 32,
    height: 32,
    transform: "rotate(90 320 384)",
    fill: "black"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 384 224)",
    fill: "black"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 256,
    width: 32,
    height: 32,
    transform: "rotate(-180 448 256)",
    fill: "black"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 96 224)",
    fill: "black"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 352 224)",
    fill: "black"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(-180 448 224)",
    fill: "black"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 64 224)",
    fill: "black"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 224,
    width: 32,
    height: 32,
    transform: "rotate(90 320 224)",
    fill: "black"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 192,
    width: 32,
    height: 32,
    transform: "rotate(-180 448 192)",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtBall);
export default __webpack_public_path__ + "static/media/pixel-art-ball.5f4fe939ce9c56ad1b1d5819b269e220.svg";
export { ForwardRef as ReactComponent };